import classof$1 from './classof.mjs';

var classof = classof$1;

var isBigIntArray = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};

export { isBigIntArray as default };
